import { render } from "./insure-team.vue?vue&type=template&id=62273c7c&scoped=true&ts=true"
import script from "./insure-team.vue?vue&type=script&lang=ts"
export * from "./insure-team.vue?vue&type=script&lang=ts"

import "./insure-team.vue?vue&type=style&index=0&id=62273c7c&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62273c7c"]])

export default __exports__